import { render } from "./CidadeComp.vue?vue&type=template&id=49d68def&scoped=true"
import script from "./CidadeComp.vue?vue&type=script&lang=js"
export * from "./CidadeComp.vue?vue&type=script&lang=js"

import "./CidadeComp.vue?vue&type=style&index=0&id=49d68def&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d68def"]])

export default __exports__